import { Injectable } from "@angular/core";
import {
    BaseNotificationEventsService,
    DssConsultationNotificationType,
    DssNotification,
    DssNotificationsService,
} from "@dtm-frontend/dss-shared-lib";
import { Notification, NotificationDisplay, SharedNotificationDisplayProps } from "@dtm-frontend/shared/notifications";
import { IconName } from "@dtm-frontend/shared/ui";
import { FunctionUtils } from "@dtm-frontend/shared/utils";
import { TranslocoService } from "@jsverse/transloco";

@Injectable({
    providedIn: "root",
})
export class AnspConsultationNotificationEventsService implements BaseNotificationEventsService {
    constructor(private readonly translocoService: TranslocoService, private readonly dssNotificationsService: DssNotificationsService) {}

    public getEventsList(notificationsToFormat: DssNotification[]): NotificationDisplay[] {
        return notificationsToFormat
            .filter((notification) =>
                this.dssNotificationsService.getDssConsultationNotificationTypes().some((type) => notification.payload.type === type)
            )
            .map((notification) => {
                const sharedProps = this.getSharedProps(notification, "user-follow");

                switch (notification.payload.type) {
                    case DssConsultationNotificationType.AssignedConsultantForRestrictionApplicationEvent:
                    case DssConsultationNotificationType.AssignedConsultantForRestrictionModificationApplicationEvent:
                        return this.getAssignedConsultantEvent(sharedProps, notification);

                    case DssConsultationNotificationType.ConsultedRestrictionApplicationEvent:
                        return this.getConsultedRestrictionApplicationEvent(sharedProps, notification);

                    case DssConsultationNotificationType.ConsultedRestrictionModificationApplicationEvent:
                        return this.getConsultedRestrictionModificationApplicationEvent(sharedProps, notification);

                    default:
                        return null;
                }
            })
            .filter(FunctionUtils.isTruthy);
    }

    private getAssignedConsultantEvent(sharedProps: SharedNotificationDisplayProps, notification: DssNotification): NotificationDisplay {
        return {
            ...sharedProps,
            title: this.translocoService.translate("dssAdmin.notifications.consultationLabel"),
            text: this.translocoService.translate("dssAdmin.notifications.assignedConsultationText"),
            redirectUrl: `consultation/${notification.payload.id}`,
        };
    }

    private getConsultedRestrictionApplicationEvent(
        sharedProps: SharedNotificationDisplayProps,
        notification: DssNotification
    ): NotificationDisplay {
        return {
            ...sharedProps,
            title: this.translocoService.translate("dssAdmin.notifications.consultationLabel"),
            text: this.translocoService.translate("dssAdmin.notifications.applicationConsultedText"),
            redirectUrl: `flight-zone/${notification.payload.id}`,
        };
    }

    private getConsultedRestrictionModificationApplicationEvent(
        sharedProps: SharedNotificationDisplayProps,
        notification: DssNotification
    ): NotificationDisplay {
        return {
            ...sharedProps,
            title: this.translocoService.translate("dssAdmin.notifications.consultationLabel"),
            text: this.translocoService.translate("dssAdmin.notifications.applicationConsultedText"),
            redirectUrl: `modifications/${notification.payload.id}`,
        };
    }

    private getSharedProps(notification: Notification, icon: IconName): SharedNotificationDisplayProps {
        return { icon, date: notification.createdAt, id: notification.id, isRead: notification.read };
    }
}
